import React, { ChangeEvent, FocusEvent, useState } from 'react'
import { Icon } from '../Icon'

interface UITextAreaProps {
  label?: string
  value?: string
  isCrossClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  autoCapitalize?: string | undefined
  error?: string | undefined
  iconName?: string
  isCross?: boolean
  rows?: number
}

const UITextArea: React.FC<UITextAreaProps> = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  iconName,
  isCross,
  isCrossClick,
  rows,
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
    onBlur
  }

  return (
    <div className="flex flex-col gap-2 w-[100%]">
      <label
        className={`text-xs font-medium ${
          error ? 'text-textError' : 'text-text1'
        }`}
      >
        {label}
      </label>
      <div
        className={`w-fill h-auto p-3 border rounded-xl flex gap-2 ${
          error
            ? 'border-textError'
            : isFocused
              ? 'border border-bluishGreen'
              : 'border-gray3'
        }`}
      >
        {iconName && (
          <Icon
            name={iconName}
            width={16}
            height={16}
            strokeWidth={1}
            stroke={error ? '#FF6666' : '#02698C'}
          />
        )}
        <textarea
          className={`w-full resize-none focus:outline-none placeholder:font-normal placeholder:text-text3 font-semibold text-[14px] text-text4 ${
            error
              ? 'placeholder-textError text-textError'
              : 'placeholder-text1 text-text1'
          }`}
          value={value}
          onBlur={handleBlur}
          onChange={onChange}
          onFocus={handleFocus}
          placeholder={placeholder}
          rows={rows}
        />
        {isCross && value && (
          <div
            onClick={isCrossClick}
            className="cursor-pointer bg-bluishGreen rounded-full w-4 h-4 flex justify-center items-center"
          >
            <Icon
              name={'IconCross'}
              width={6}
              height={6}
              strokeWidth={1.5}
              stroke={'#FFFFFF'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default UITextArea
